import { Skeleton, Stack } from '@mui/material'

import { useOrderStepUnsubscribeData } from '../../../../../../orderNotificationAtom'

import { UnsubscribeDataEmail } from './components/UnsubscribeDataEmail'
import { UnsubscribeDataFailed } from './components/UnsubscribeDataFailed'
import { UnsubscribeDataSms } from './components/UnsubscribeDataSms'

type Props = {
  extendedOrder: uui.domain.client.rm.ExtendedOrderStep
  status: 'loading' | 'failed' | 'ready'
}

export function OrderStepUnsubscribeInfo(props: Props) {
  const { extendedOrder, status } = props

  const unsubscribedData = useOrderStepUnsubscribeData(extendedOrder.id)

  if (status === 'loading') {
    return (
      <Stack direction="column">
        <Skeleton variant="rectangular" height={16} width="30%" />
        <Skeleton variant="rectangular" height={40} width="100%" sx={{ mt: '12px' }} />
      </Stack>
    )
  }

  if (status === 'failed') {
    return <UnsubscribeDataFailed />
  }

  if (
    !unsubscribedData ||
    (!unsubscribedData.email.unsubscribed && !unsubscribedData.sms.unsubscribed)
  )
    return null

  return (
    <>
      {unsubscribedData.email.unsubscribed && (
        <UnsubscribeDataEmail
          email={extendedOrder.orderStep.email ?? ''}
          date={unsubscribedData.email.unsubscribeDate}
        />
      )}
      {unsubscribedData.sms.unsubscribed && (
        <UnsubscribeDataSms
          phoneNumber={extendedOrder.orderStep.phone ?? ''}
          date={unsubscribedData.sms.unsubscribeDate}
        />
      )}
    </>
  )
}
